import React from 'react';
import { Zap } from 'lucide-react';
export function PainSection() {
  return <section className="bg-slate-900 text-slate-300 py-20 px-4 border-t border-slate-800" data-id="element-215">
      <div className="max-w-3xl mx-auto" data-id="element-216">
        <div className="flex items-center justify-center mb-12" data-id="element-217">
          <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center border border-red-500/20" data-id="element-218">
            <Zap className="w-8 h-8 text-red-500" data-id="element-219" />
          </div>
        </div>

        <div className="space-y-8 text-lg md:text-xl leading-relaxed" data-id="element-220">
          <p className="font-bold text-2xl text-white" data-id="element-221">
            Son las 2:07 de la mañana.
          </p>

          <p data-id="element-222">Solo intentas acomodarte un poco en la cama.</p>

          <p data-id="element-223">Y entonces llega.</p>

          <p className="text-white font-bold border-l-4 border-blue-500 pl-6 py-2 bg-slate-800/50 rounded-r-lg" data-id="element-224">
            Ese <span className="text-blue-400" data-id="element-225">choque eléctrico</span> que
            atraviesa el glúteo, se dispara por el muslo y te deja con la
            respiración cortada, los dientes apretados, inmóvil en la oscuridad.
          </p>

          <p data-id="element-226">No es la primera vez.</p>

          <p data-id="element-227">Y sabes exactamente lo que viene después.</p>

          <p data-id="element-228">Esa niebla de ansiedad que llega junto con el dolor:</p>

          <div className="pl-8 space-y-4 italic text-slate-400 border-l-2 border-slate-700" data-id="element-229">
            <p data-id="element-230">"¿Voy a poder manejar mañana?"</p>
            <p data-id="element-231">"¿Podré estar sentado en la reunión de las 9?"</p>
            <p data-id="element-232">
              "¿Voy a tener que volver a pedirle a alguien que me ate los
              zapatos?"
            </p>
          </div>

          <p className="text-2xl font-bold text-white mt-12" data-id="element-233">
            Y lo más agotador no es el dolor en sí.
          </p>

          <p className="text-2xl font-extrabold text-red-400 bg-red-950/30 p-4 rounded-lg border border-red-900/50 text-center" data-id="element-234">
            Es vivir con ese miedo constante de cuándo va a volver.
          </p>

          <div className="w-full h-px bg-slate-800 my-12" data-id="element-235"></div>

          <p data-id="element-236">Hace unos meses, quizás te dijiste que era algo temporal.</p>

          <p className="italic text-slate-400" data-id="element-237">
            "Me paso. Solo necesito descansar."
          </p>

          <p data-id="element-238">Pero los días se convirtieron en semanas.</p>

          <p data-id="element-239">Las semanas en meses.</p>

          <p data-id="element-240">Y el ritual es siempre el mismo:</p>

          <p className="leading-loose" data-id="element-241">
            Te despiertas. Intentas moverte. El nervio te da un aviso. Llegas al
            baño como si tuvieras 80 años. Tomas algo para el dolor. Esperas que
            funcione. Sales a trabajar con la quijada apretada. Llegas a casa
            agotado — no de trabajar, sino de{' '}
            <strong className="text-white" data-id="element-242">
              luchar contra tu propio cuerpo durante 10 horas seguidas.
            </strong>
          </p>

          <p data-id="element-243">Tu pareja te ha visto cambiar.</p>

          <p data-id="element-244">Tus hijos ya saben que papá (o mamá) "tiene la espalda mal".</p>

          <p data-id="element-245">Y tú empiezas a aceptar que quizás esto es para siempre.</p>

          <p className="text-2xl font-extrabold text-orange-400 text-center pt-8" data-id="element-246">
            Eso no es verdad. Y no está en tu columna. Está en el ángulo.
          </p>
        </div>
      </div>
    </section>;
}